
import jwtDecode from 'jwt-decode';
import { Cookies } from 'react-cookie';

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const user = getLoggedInUser()

    if (!user) {
        return null
    }
    
    const decoded = jwtDecode(user.id_token)
    return isSessionValid(decoded)
};

const isSessionValid = (user) => {
    //check input, typescript would save us here
    if (!user || !user.exp) {
        return false
    }
    //FIXME: logic here could be vulnerable to a hack by changing the system time
    const currentTime = Date.now() / 1000;
    if (user.exp < currentTime) {
        return false;
    } else {
        return true;
    }
};

/**
 * Returns the logged in user, encoded
 */
const getLoggedInUser = () => {
    const cookies = new Cookies();
    let user = cookies.get('user');
    user = user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;

    if (!user) {
        return null;
    }

    if (typeof user == 'object') {
        return user
    }
    else {
        return JSON.parse(user)
    }
};

/**
 * Returns the logged in user, decoded
 */
const getLoggedInUserDecoded = () => {
    const user = getLoggedInUser();
    
    if (!user) {
        return null;
    }

    const decoded = jwtDecode(user.id_token)
    return decoded;
};

/**
 * @returns {string|null} - The role of the logged in user or null if not found
 * 0   → Anyone here is used as "Route"
 * route: privateRoute
 * Roles: 
 *   1 → Regular User 
 *   2 → Manager (can see reports, Maybe Cashflow)
 *   3 → Admin (User Management {Add, Delete, Reset Password email for user to do it} , Refresh loans API Source, Cashflow, All Reports}
 */
const getLoggedInUserRole = () => {
    const user = getLoggedInUserDecoded();
    
    if (!user) {
        return null;
    }

    if (user && user.role) {
        return user.role
    }
    else {
        return null
    }
};

export { isUserAuthenticated, getLoggedInUser, getLoggedInUserRole, isSessionValid, getLoggedInUserDecoded };
